import Home from "../pages/Home";

export const RouteList = [
  {
    component: <Home />,
    path: "/index",
    title: "",
  },
  {
    component: <Home />,
    path: "/",
    title: "",
  },
];
